export default __webpack_public_path__ + "static/media/warning.173f100d.svg";